import { Injectable } from '@angular/core';
import { IEletronicSignature } from '@services/strategy-pattern-login/iEletronic-Signature';

@Injectable({
  providedIn: 'root'
})
export class IEletronicSignatureApiService implements IEletronicSignature {

  constructor() { }

  getSignatureParameters() {
    throw new Error('Method not implemented.');
  }

  validateSignature(signature: any) {
    throw new Error('Method not implemented.');
  }

  forgotPassword() {
    throw new Error('Method not implemented.');
  }

}
